<template>
    <div>
        <div v-if="$showModal('addPost')" class="custom_popup_wrapper">
            <div id="add_post" class="custom_popup_inner">
                <div
                    id="add_job"
                    v-click-outside="$closeModal"
                    class="b_modal white_modal mfp-hide zoom-anim-dialog"
                >
                    <div class="modal_content_inner">
                        <add-form :board-id="boardId" @on-save="onSave" />
                    </div>
                    <button
                        title="Close (Esc)"
                        type="button"
                        class="mfp-close"
                        @click="$closeModal"
                    >
                        ×
                    </button>
                </div>
            </div>
        </div>
        <post-thank-you />
    </div>
</template>
<script>
import AddForm from '@/components/boards/AddForm';
import PostThankYou from '@/components/modals/PostThankYou';

export default {
    components: {
        AddForm,
        PostThankYou
    },

    props: {
        boardId: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            error: '',
            post: {}
        };
    },

    methods: {
        onSave(post) {
            this.$closeModal();

            this.$emit('added', post);

            this.$openModal('postThanks');
        }
    }
};
</script>
